import { API, createJsonHeaders } from "app/api";
import { FEEDBACK, API_BASE_URL } from "./constants";

export const fetchFeedback = params => {
  const { id, feature = {}, topicId, ruleName, locationObjectTitle } = params;
  const url = `${API_BASE_URL}/generic/execute?name=${topicId}$${ruleName}&epsg=4326&latLon=false`;
  const body = JSON.stringify({
    ...feature,
    properties: {
      ...feature.properties,
      objectname: locationObjectTitle
    }
  });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    ui: { showToastOnError: true },
    payload: {
      id,
      request,
      ...FEEDBACK
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/feedback/actions.js